// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
class ProductCarouselNarrow extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(this.els.slides.element, this.options(), [
      setInitialised(),
      addWheelControls('horizontal'),
    ])
  }

  options () {
    return {
      selector: this.els.slide.selector,
      loop: false,
      mode: 'free-snap',
      defaultAnimation: {
        duration: config.defaultAnimation.duration,
      },
      dragSpeed: config.dragSpeed,
      slides: {
        perView: 'auto',
        spacing: 20,
      },
    }
  }
}

if (!customElements.get('product-carousel-narrow')) {
  customElements.define('product-carousel-narrow', ProductCarouselNarrow)
}
